//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/FacetCollector.js";
import "../no/Expression.js";
import "../no/FacetCollector.js";
let d=[[[0,"AngularThreshold",1,0],[1,"AverageSize",0,"Expression",0],[0,"ChordalTolerance",1,0],[1,"FacetRegion",0,"FacetCollector",0],[0,"IsEditCopy",1,0],[0,"IsLockBoundary",1,0],[0,"IsShowDeviationPlot",1,0],[1,"MaximumSize",0,"Expression",0],[0,"RemeshMode",1,0],[0,"SharpEdgesLockOption",1,0]],[],[]];
SPLM.Facet.RemeshFacetBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.RemeshFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.RemeshFacetBodyBuilder.RemeshModeType = Object.freeze({
    "Constant" : "Constant", "Variable" : "Variable"});

SPLM.Facet.RemeshFacetBodyBuilder.SharpEdgesLockType = Object.freeze({
    "NoLock" : "NoLock", "SoftLock" : "SoftLock", "HardLock" : "HardLock"});

export default SPLM;